import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';
import user from 'features/views/user';

import * as types from './actionTypes';

export const setRegions = createAction(types.SET_REGIONS, (regions) => ({ regions }));
export const setHoveredRegionId = createAction(types.SET_HOVERED_REGION_ID, (id) => ({ id }));
export const setRegionActivity = createAction(types.SET_REGION_ACTIVITY, (regionId, active) => ({ regionId, active }));
export const setRegionsActivity = createAction(types.SET_REGIONS_ACTIVITY, (active) => ({ active }));
export const setRegionGuarantors = createAction(types.SET_REGION_GUARANTORS, (regionId, guarantors) => ({
	regionId,
	guarantors,
}));

export const fetchRegions = (campaignId) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.campaignGuarantorRegion, {
			replaceParams: { id: campaignId },
			onSuccess: [
				(response) => () => {
					const data = response.body;
					if (!data || !Array.isArray(data)) return;
					dispatch(setRegions(data));
				},
			],
		}),
	);
};

export const activateAllRegions = (campaignId) => (dispatch) => {
	dispatch(
		fetch.actions.put(fetch.constants.urls.campaignGuarantorActiveAllRegions, {
			replaceParams: { id: campaignId },
			onSuccess: [
				() => () => {
					dispatch(user.actions.fetchAdditionalUserInfo());
					dispatch(setRegionsActivity(true));
				},
			],
		}),
	);
};

export const activateRegion = (campaignId, region) => (dispatch) => {
	dispatch(
		fetch.actions.put(fetch.constants.urls.campaignGuarantorActiveRegion, {
			replaceParams: { id: campaignId, regionId: region.id },
			onSuccess: [
				() => () => {
					dispatch(user.actions.fetchAdditionalUserInfo());
					dispatch(setRegionActivity(region.id, true));
				},
			],
		}),
	);
};

export const deactivateAllRegions = (campaignId) => (dispatch) => {
	dispatch(
		fetch.actions.deleteRequest(fetch.constants.urls.campaignGuarantorActiveAllRegions, {
			replaceParams: { id: campaignId },
			onSuccess: [
				() => () => {
					dispatch(user.actions.fetchAdditionalUserInfo());
					dispatch(setRegionsActivity(false));
				},
			],
		}),
	);
};

export const deactivateRegion = (campaignId, region) => (dispatch) => {
	dispatch(
		fetch.actions.deleteRequest(fetch.constants.urls.campaignGuarantorActiveRegion, {
			replaceParams: { id: campaignId, regionId: region.id },
			onSuccess: [
				() => () => {
					dispatch(user.actions.fetchAdditionalUserInfo());
					dispatch(setRegionActivity(region.id, false));
				},
			],
		}),
	);
};
